<div class="{{ OBJ_LNG_NAME }} chooseIcon width100">

    <h1 mat-dialog-title>
        {{ 'allgemein.auswählen' | translate:locale.language:{ typ: 'icon.typ' | translate:locale.language } }}
        <button mat-icon-button type="button" mat-dialog-close><mat-icon aria-label="Schließen">close</mat-icon></button>
        <mat-progress-bar *ngIf="seconddialogrunningajaxcall" color="primary" mode="indeterminate"></mat-progress-bar>
    </h1>

    <mat-dialog-content>
        <form *ngIf="aktuellicons" #chooseIconForm="ngForm" class="{{ OBJ_LNG_NAME }} chooseIconForm">
            <p class="errors" *ngIf="fehlerMain" [innerHTML]="fehlerMain.messagehtml"></p>

        <div class="iconchoosecontainer">
            <div fxLayout="row wrap" fxLayoutAlign="stretch" fxFlex>
                <div fxFlex="1 1 calc(3em + 16px)" fxLayoutAlign="stretch" *ngFor="let icon of aktuellicons">
                    <mat-card appearance="outlined">
                        <button mat-icon-button (click)="iconAuswaehlen(icon)"><mat-icon>{{ icon }}</mat-icon></button>
                    </mat-card>
                </div>
            </div>
        </div>
        </form>
    </mat-dialog-content>

</div>
